import React from 'react';
import { PropTypes } from 'prop-types';
import ShowComponent from '../hocs/ShowComponent';

@ShowComponent
class ToggleComponent extends React.Component {
  constructor(props) {
    super(props);

    this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange(event) {
    /* Add state to contact form data */
    this.props.handleInputChange(event);
  }

  render() {
    const { checked, id, label } = this.props;

    /* Set condition for active state */
    const checkedClassActive = (checked) ? 'slider--unchecked' : '';
    const labeltext = (label) ? `${label}:` : '';

    return (
      <div className={this.props.classNames}>
        <div className="label">{labeltext}</div>
        {this.props.children}
        <label htmlFor={id} className={`switch ${checkedClassActive}`} >
          <input onChange={this.handleInputChange} checked={checked} type="checkbox" id={id} />
          <div className="slider round" />
        </label>
      </div>
    );
  }
}

ToggleComponent.propTypes = {
  id: PropTypes.string,
  checked: PropTypes.bool,
  label: PropTypes.string,
  classNames: PropTypes.string,
  handleInputChange: PropTypes.func,
  children: PropTypes.node,
};

ToggleComponent.defaultProps = {
  id: '',
  checked: false,
  classNames: '',
  label: '',
  handleInputChange: () => {},
  children: '',
};

export default ToggleComponent;
